




















import Vue from 'vue';
import RestX from 'highered-utils/restx';

// Services
import TalkJSService, { ChatUser } from '~/services/TalkJSService';
import AuthService from '~/services/AuthService';
import CompanyService from '~/services/CompanyService';
import { ConversationBuilder, Inbox, Session } from 'talkjs/all';
import { VFairOrganization } from '~/services/types/vfair';

// Components
import ChatUserCarouselItem from '../../companydetail/components/ChatUser.CarouselItem.vue';

// Utils
import CommunicationService from '~/services/CommunicationService';
import { uuidFromURLParam } from '~/utils/urlUtils';
import { StudyProgram } from '~/services/types/csp';
import { RestXReactiveData } from '~/utils/types';

export default Vue.extend({
    name: 'VFairChat',
    data() {
        return {
            companies: [] as VFairOrganization[],
            chatUsers: null as null | ChatUser[],
            conversations: null as any[] | null,
            isLoading: true,
            session: null as null | Session,
            inbox: null as null | Inbox,
            getUserInterval: 10000,
            userIntervals: 0,
        };
    },
    computed: {
        vFairId(): string {
            return uuidFromURLParam(this.$route.params.id) || '';
        },
        interfaces(): any {
            return (this as any).$interfaces;
        },
    },
    methods: {
        getCarouselComponent(): any {
            return ChatUserCarouselItem;
        },
        async chatUserClick(chatUser: ChatUser): Promise<void> {
            if (!AuthService.isLoggedIn()) {
                (RestX.getInterfaces() as any).logInModule.toggleOpen();
                return;
            }

            if (this.conversations == null) {
                this.conversations = await this.getConversations();
            }

            if (!this.session || !this.inbox || !this.conversations) return;

            const existingConversation = this.conversations.find(conv => {
                if (typeof conv.participants[0] === 'undefined') return false;
                return conv.participants[0].id === chatUser.id;
            });

            if (existingConversation) {
                const conv = this.session.getOrCreateConversation(existingConversation.id);
                this.inbox.select(conv);
                return;
            }

            const newConv = await this.interfaces.communication.chat.conversation.post({
                body: {
                    participants: [chatUser.id, this.session.me.id],
                },
            });

            this.conversations.push(newConv);

            if (this.session && this.inbox) {
                const conv = this.session.getOrCreateConversation(newConv.id);
                this.inbox.select(conv);
            }
        },
        async getConversations(): Promise<ConversationBuilder[]> {
            return (await this.interfaces.communication.chat.conversation.get()).data;
        },
        async getChatUser(): Promise<ChatUser> {
            return this.$store.getters['profileModule/awaitMostRelevantSchool']()
                .then((s: StudyProgram['school'] | null) => {
                    return this.interfaces.communication.chat.user.me.get({
                        school_id: s ? s.id : undefined,
                        school_name: s ? s.name : undefined,
                    });
                })
                .then((res: RestXReactiveData<ChatUser>) => {
                    return res.data;
                });
        },
        async getCompanies(): Promise<VFairOrganization[]> {
            return (await CompanyService.getVFairCompanies(this.vFairId)).data;
        },
        async getChatUsers(): Promise<ChatUser[]> {
            return CommunicationService.getChatAvilabilityMany(
                this.companies.map(c => c.organizationId)
            );
        },
    },
    beforeDestroy() {
        clearInterval(this.userIntervals);
    },
    async mounted() {
        // Init TalkJS session
        const chatUser = await this.getChatUser();
        this.session = TalkJSService.getSession(chatUser);

        this.userIntervals = setInterval(async () => {
            this.chatUsers = await this.getChatUsers();
        }, this.getUserInterval);

        // Fetch data
        this.companies = await this.getCompanies();
        this.chatUsers = await this.getChatUsers();
        this.conversations = await this.getConversations();

        // Initialize TalkJS session and inbox
        this.inbox = this.session.createInbox();
        this.isLoading = false;
        setTimeout(() => {
            if (!this.inbox) return;
            this.inbox.mount(document.getElementById('talkjs-container'));
        }, 100);
    },
});
